module.exports = __webpack_public_path__ + "static/media/undraw_group_video.d1dc4f40.svg";